import React, { useState } from "react";
import {
    Language,
} from "../../assets/icons/icons";
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from "react";


export default function LangRes() {
    const { i18n } = useTranslation();
    const [isOpenLanguage, setIsOpenLanguage] = useState(false);
    const dropdownRef = useRef(null);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpenLanguage(false);
    };

    useEffect(() => {

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpenLanguage(false);
            }
        };


        document.addEventListener('click', handleClickOutside);


        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {

        i18n.on('languageChanged', (lng) => {
            document.documentElement.lang = lng;
            document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
        });
    }, [i18n]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpenLanguage(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative z-10" ref={dropdownRef}>
            <button
                onClick={() => setIsOpenLanguage(!isOpenLanguage)}
                className="flex items-center gap-2 p-2 text-[#666666] font-bold rounded-md"
            >
                <Language />
            </button>
            {isOpenLanguage && (
                <div className="absolute z-1000 right-min right-0 mt-2 w-40 bg-white shadow-lg rounded-md">
                    <div className="py-1">
                        <button
                            onClick={() => changeLanguage('en')}
                            className="w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-t-md"
                        >
                            English
                        </button>
                        <button
                            onClick={() => changeLanguage('ar')}
                            className="w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-b-md"
                        >
                            العربية
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}